// CRM cannot accept these ASCII control characters. Tabs, LF and CR are allowed.
// eslint-disable-next-line no-control-regex
const invalidControlCharacters = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/;

export const sanitizeText = (value: string): string =>
  value.replace(new RegExp(invalidControlCharacters.source, 'g'), '');

